import { render } from "./PerformerBadge.vue?vue&type=template&id=43e52a0d&ts=true"
import script from "./PerformerBadge.vue?vue&type=script&lang=ts"
export * from "./PerformerBadge.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__